import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IPostVodafoneServices } from '../models/models'

export class PutAuthorizedServicesVodafoneApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/authorizedServicesVodafone/updateVodafoneService',
      requesterInfo,
    })
  }

  public async putAuthorizedServicesMain(request: IPostVodafoneServices): Promise<IPostVodafoneServices> {
    return await this.postAsync<IPostVodafoneServices>(request)
  }
}
